import { Language, LANGUAGES } from '@stores/LanguageStore';

export const toPath = (pathname: string): string[] => {
  return pathname.split('/').filter((path) => path);
};

export const pathStartsWithLang = (path: string[]): boolean => {
  return path && (path.length > 0) && LANGUAGES.includes(path[0]);
};

export const langFromPath = (path: string []): Language => {
  return pathStartsWithLang(path) ? (path[0] as Language) : null;
};

export const toPathname = (path: string[]): string => {
  return `/${path.join('/')}`;
};

export const pathWithoutLang = (path: string[]): string[] => {
  return pathStartsWithLang(path) ? path.slice(1) : path;
};
